import BaseFeature from '../../foundation/base/base';
import { detectBrowser, Browsers } from '../../foundation/utilities/detectBrowsers';

class Accordion2Cols extends BaseFeature {
	constructor(element) {
		super(element);

		this.el = element;
		this.wrapper = this.el.querySelectorAll('.o-accordion-2-cols__wrapper');
		this.allContentLinks = document.querySelectorAll('.o-accordion-2-cols__content a');
		this.deepLink = document.querySelectorAll('.o-accordion-2-cols a');
		this.accordionIframe = document.querySelectorAll('.o-accordion-2-cols__content iframe');
		this.activeClass = 'o-accordion-2-cols__wrapper--active';
		this.panes();
	}

	panes() {
		const deepLink = window.location.hash.substring(1);

		for (let i = 0; i < this.wrapper.length; i++) {
			const clickItem = this.wrapper[i].querySelector('.o-accordion-2-cols__header');
			const accordionItem = this.wrapper[i];

			// Make iframe NonTabable
			this.accordionIframe.forEach((iframe) => {
				iframe.setAttribute('tabindex', '-1');
			});

			// Make deep links NonTabable
			this.deepLink.forEach((link) => {
				link.setAttribute('tabindex', '-1');
			});

			// Make the links inside accordion NonTabable
			this.allContentLinks.forEach((link) => {
				link.setAttribute('tabindex', '-1');
			});

			clickItem.classList.add('o-accordion-2-cols__header--hide-outline');

			clickItem.addEventListener('click', () => {
				clickItem.classList.add('o-accordion-2-cols__header--hide-outline');

				const setClasses = !accordionItem.classList.contains(this.activeClass);
				// this removes all activeClass instances so that other panes will close
				// when opening other panes
				// also if user clicks on open pane it closes which is the acceptance criteria
				this.setClass(this.wrapper, this.activeClass, 'remove');
				clickItem.setAttribute('aria-expanded', 'false');


				if (setClasses) {
					accordionItem.classList.toggle(this.activeClass);
					clickItem.setAttribute('aria-expanded', 'true');
					this.wrapper[i].querySelectorAll('a').forEach((elementItemLinks) => {
						elementItemLinks.setAttribute('tabindex', '0');
					});
					this.wrapper[i].querySelectorAll('iframe').forEach((elementIframe) => {
						elementIframe.setAttribute('tabindex', '0');
					});
				} else {
					this.wrapper[i].querySelectorAll('a').forEach((elementItemLinks) => {
						elementItemLinks.setAttribute('tabindex', '-1');
					});
					this.wrapper[i].querySelectorAll('iframe').forEach((elementIframe) => {
						elementIframe.setAttribute('tabindex', '-1');
					});
				}
			});

			clickItem.addEventListener('keyup', (e) => {
				if (e.code === 'Tab') {
					clickItem.classList.remove('o-accordion-2-cols__header--hide-outline');
				}
			});


			// WCAG
			window.addEventListener('keyup', (e) => {
				const isFocused = document.activeElement === clickItem;
				if (isFocused && e.code === 'Enter') {
					e.preventDefault();
					// Remove all the tabindex first
					this.allContentLinks.forEach((link) => {
						link.setAttribute('tabindex', '-1');
					});
					this.accordionIframe.forEach((iframe) => {
						iframe.setAttribute('tabindex', '-1');
					});
					// Add the click event
					setTimeout(() => {
						clickItem.click();
					}, 5);
				}
			});


			// Because of IE11 we have to have this setTimeout.
			// otherwise accordions stops working in IE11
			const isIE = detectBrowser(Browsers.IE);
			let delay;
			// eslint-disable-next-line no-unused-expressions
			isIE ? delay = 300 : delay = 0;

			window.setTimeout(() => {
				if (accordionItem.classList.contains(deepLink)) {
					accordionItem.classList.add(this.activeClass);
				}
			}, delay);
		}
	}

	// eslint-disable-next-line class-methods-use-this
	setClass(els, className, fnName) {
		for (let i = 0; i < els.length; i++) {
			els[i].classList[fnName](className);
		}
	}
}


export default Accordion2Cols;
